import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core'
import { FloDebugService } from '../services/debug.service'
import { VerticalService } from '../../../singleton-services/vertical.service'
import { map } from 'rxjs/operators'
import { HttpParams } from '@angular/common/http'
import { LocationService } from '../../../singleton-services/location.service'
import { maybe } from 'typescript-monads'
import { ActivatedRoute } from '@angular/router'
import { AuthService } from 'src/app/singleton-services/auth/auth.service'
import { ViewAsService } from 'src/app/singleton-services/view-as.service'
import { combineLatest } from 'rxjs'

@Component({
  selector: 'flo-debug-menu',
  styleUrls: ['./debug-menu.component.scss'],
  templateUrl: './debug-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FloDebugMenuComponent {
  isCollapsed = false

  constructor(
    public readonly debug: FloDebugService,
    public readonly vs: VerticalService,
    public readonly loc: LocationService,
    public readonly ar: ActivatedRoute,
    public readonly auth: AuthService,
    public readonly viewAsService: ViewAsService
  ) {}

  get isViewingAsUser() {
    return this.viewAsService.isViewingAsUser$
  }

  get viewedUserInfo() {
    return this.viewAsService.viewedUserInfo$
  }

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed
  }

  siteCodes$ = this.vs.getAllSiteCodes.pipe(map(a => a.reduce((acc, curr) => ({ ...acc, [curr]: curr }), {})))

  selectMenuItems$ = this.siteCodes$

  canViewAsUser$ = combineLatest([this.auth.isEmployee$, this.auth.isAdmin$]).pipe(
    map(([isEmployee, isAdmin]) => isEmployee && isAdmin)
  )

  @HostListener('document:keydown', ['$event'])
  onKeyDown(evt: KeyboardEvent) {
    if (evt.ctrlKey && evt.shiftKey && evt.key === 'D') {
      this.debug.toggle()
    }
  }

  trackBySiteCode(_idx: number, code: string) {
    return code
  }

  changeVertical(flosite: string) {
    const split = this.loc.href.split('?')
    const base = split[0]
    const href = maybe(split[1])
      .map(fromString => new HttpParams({ fromString }).set('flosite', flosite).toString())
      .match({
        none: () => `${base}?${new HttpParams({ fromObject: { flosite } }).toString()}`,
        some: params => `${base}?${params}`
      })
    window.location.href = href
  }
}
